<template>
  <div class="image-preview-fallback">
    <FallbackImage
      class="image-preview-fallback__image"
      data-test-id="image-preview-fallback-image"
    />
    <p class="image-preview-fallback__title" data-test-id="image-preview-fallback-title">
      We couldn’t load the image.
    </p>
    <p class="image-preview-fallback__hint" data-test-id="image-preview-fallback-hint">
      Please try again later.
    </p>
  </div>
</template>

<script>
import FallbackImage from '~~/common/vue/assets/images/placeholder.svg';

export default {
  components: {
    FallbackImage,
  },
};
</script>

<style lang="scss" scoped>
.image-preview-fallback {
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: $color-background-secondary;
  color: $color-text-secondary;
  text-align: center;
  padding: $space-m;
}

.image-preview-fallback__title,
.image-preview-fallback__hint {
  margin: 0;
}

.image-preview-fallback__title {
  font-size: $font-m;
}
</style>
